(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-purchase-clearance"] && !Shopify.designMode) return;
  try {
    (() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const hiddenClass = 'matf-purchase-clearance-hidden';
  const managedClass = 'matf-purchase-clearance-managed';
  const controlSelector = '.main-product-atc, .rebuy-cart__checkout-button, button[name="checkout"], input[name="checkout"]';
  const observed = new WeakSet();
  const originalInert = new WeakMap();
  const restoreAfter = new Map();
  let restoreTimer;
  let controls = [];
  let controlsDirty = true;
  let scheduled = false;

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };

  const watch = (root, attributes = false) => {
    if (!root || observed.has(root)) return;
    observed.add(root);
    new MutationObserver(records => {
      if (records.some(record => record.type === 'childList')) controlsDirty = true;
      schedule();
    }).observe(root, {
      childList: true,
      subtree: true,
      attributes,
      ...(attributes ? { attributeFilter: ['aria-expanded', 'class', 'hidden'] } : {})
    });
  };

  const overlaps = (rect, target, clearance) =>
    rect.width > 0 && rect.height > 0 &&
    rect.left < target.right + clearance && rect.right > target.left - clearance &&
    rect.top < target.bottom + clearance && rect.bottom > target.top - clearance;

  const setHidden = (element, hidden) => {
    if (!element) return;
    if (hidden && !originalInert.has(element)) {
      originalInert.set(element, element.inert);
    }
    if (element.classList.contains(hiddenClass) !== hidden) {
      element.classList.toggle(hiddenClass, hidden);
    }
    if (hidden) {
      if (!element.inert) element.inert = true;
    } else if (originalInert.has(element)) {
      element.inert = originalInert.get(element);
      originalInert.delete(element);
    }
  };

  const updateLauncher = (element, closed, blocked, now) => {
    if (!element) return;
    const managed = mobile.matches && closed;
    if (element.classList.contains(managedClass) !== managed) {
      element.classList.toggle(managedClass, managed);
    }
    if (!managed || blocked) {
      restoreAfter.delete(element);
      setHidden(element, managed && blocked);
    } else if (originalInert.has(element)) {
      if (!restoreAfter.has(element)) restoreAfter.set(element, now + 180);
      if (now >= restoreAfter.get(element)) {
        restoreAfter.delete(element);
        setHidden(element, false);
      } else {
        setHidden(element, true);
      }
    }
  };

  function update() {
    scheduled = false;
    if (controlsDirty) {
      controls = Array.from(document.querySelectorAll(controlSelector));
      controlsDirty = false;
    }
    const purchaseRects = mobile.matches ? controls
      .filter(element => element.getClientRects().length &&
        getComputedStyle(element).visibility !== 'hidden')
      .map(element => element.getBoundingClientRect()) : [];
    const isBlocked = (element, owner = element) => {
      if (!element || !mobile.matches) return false;
      const rect = element.getBoundingClientRect();
      const clearance = originalInert.has(owner) ? 96 : 48;
      return purchaseRects.some(purchase => overlaps(purchase, rect, clearance));
    };

    const rewards = document.querySelector('.smile-launcher-frame-container');
    watch(rewards, true);
    const rewardsClosed = Boolean(rewards?.classList.contains('smile-launcher-closed'));
    const rewardsBlocked = rewardsClosed && isBlocked(rewards);

    const chat = document.querySelector('shopify-chat');
    const shell = chat?.shadowRoot;
    watch(shell, true);
    const runtime = shell?.querySelector('shopify-agent-runtime');
    watch(runtime?.shadowRoot, true);
    const activator = runtime?.shadowRoot?.querySelector('[part~="activator"]');
    const chatClosed = activator?.getAttribute('aria-expanded') === 'false';
    const chatBlocked = chatClosed && isBlocked(activator, chat);

    const now = performance.now();
    updateLauncher(rewards, rewardsClosed, rewardsBlocked, now);
    updateLauncher(chat, chatClosed, chatBlocked, now);
    clearTimeout(restoreTimer);
    for (const element of restoreAfter.keys()) {
      if (!element.isConnected) restoreAfter.delete(element);
    }
    if (restoreAfter.size) {
      restoreTimer = setTimeout(schedule, Math.max(0, Math.min(...restoreAfter.values()) - now) + 1);
    }
  }

  watch(document.body);
  window.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', () => {
    controlsDirty = true;
    schedule();
  });
  window.addEventListener('load', schedule, { once: true });
  [0, 500, 1500, 3000, 6000, 10000].forEach(delay => setTimeout(schedule, delay));
})();
  } catch(e) { console.error(e); }
})();

})();
